module.exports = __webpack_public_path__ + "img/群聊内容监测.9753ac35.png";